const AiIcon = ({ width, height }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width || "40"}
      height={height || "40"}
      viewBox="0 0 312 312"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
      aria-labelledby="ai-icon"
    >
      <title id="ai-icon" />
      <g clipPath="url(#clip0_5039_9533)">
        <mask
          id="mask0_5039_9533"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="100"
          y="20"
          width="176"
          height="288"
        >
          <path
            d="M143.658 21.5516L106.496 39.3631C101.58 41.7193 99.496 47.6339 101.841 52.5738L219.953 301.406C222.298 306.346 228.183 308.441 233.099 306.084L270.261 288.273C275.177 285.917 277.261 280.002 274.917 275.062L156.805 26.2297C154.46 21.2898 148.574 19.1954 143.658 21.5516Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_5039_9533)">
          <path
            d="M152.559 17.2853L97.5952 43.6294L224.198 310.351L279.162 284.007L152.559 17.2853Z"
            fill="#DB0007"
          />
          <path
            d="M184.994 75.2554L125.084 106.521L97.5695 43.5938L152.549 17.2339L184.994 75.2554Z"
            fill="#FFBC0D"
          />
        </g>
        <path
          d="M147.864 20.555C151.562 20.555 155.063 22.636 156.789 26.2035L274.932 275.037C277.299 279.992 275.179 285.888 270.297 288.266L233.119 306.054C231.738 306.698 230.308 307.045 228.878 307.045C225.18 307.045 221.679 304.964 219.953 301.397L101.81 52.5634C99.4432 47.6085 101.563 41.7122 106.445 39.3339L143.624 21.5459C145.004 20.9018 146.434 20.555 147.864 20.555ZM147.864 15.6001C145.645 15.6001 143.525 16.0956 141.503 17.037L104.374 34.825C100.824 36.5592 98.1118 39.5321 96.7805 43.2978C95.4492 47.0635 95.6957 51.0769 97.3722 54.6444L215.516 303.478C217.981 308.631 223.208 311.951 228.878 311.951C231.097 311.951 233.217 311.455 235.239 310.514L272.418 292.726C275.968 290.991 278.68 288.019 280.011 284.253C281.342 280.487 281.096 276.474 279.419 272.906L161.227 24.0729C158.761 18.9199 153.535 15.6001 147.864 15.6001Z"
          fill="black"
        />
        <path
          d="M123.752 105.778L181.443 78.1294"
          stroke="black"
          strokeWidth="7.8"
          strokeMiterlimit="10"
        />
        <path
          d="M200.772 168.607C203.977 167.071 213.05 179.458 221.038 196.255L225.673 194.025C217.093 175.94 205.407 163.503 199.638 166.278C196.334 167.864 195.496 173.661 196.828 181.489C191.65 175.494 186.621 172.521 183.317 174.107C177.548 176.881 179.816 193.827 188.396 211.912L193.08 209.683C185.092 192.886 181.246 178.021 184.451 176.436C187.656 174.85 196.236 186.246 203.632 201.755L208.267 199.525C200.92 184.016 197.518 170.192 200.772 168.656"
          fill="#FFBC0D"
        />
        <path
          d="M53.1425 100.824C53.1425 89.7748 44.4148 80.856 33.6656 80.856C44.4148 80.856 53.1425 71.8877 53.1425 60.8879C53.1425 71.9373 61.8701 80.856 72.6193 80.856C61.8701 80.856 53.1425 89.8244 53.1425 100.824Z"
          fill="#FFBC0D"
          stroke="black"
          strokeWidth="6.24"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M220.15 55.3866C220.15 45.4273 212.261 37.3509 202.547 37.3509C212.261 37.3509 220.15 29.2745 220.15 19.3152C220.15 29.2745 228.04 37.3509 237.753 37.3509C228.04 37.3509 220.15 45.4273 220.15 55.3866Z"
          fill="#FFBC0D"
          stroke="black"
          strokeWidth="6.24"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.5024 163.601C84.5024 145.516 70.2029 130.899 52.5505 130.899C70.2029 130.899 84.5024 116.233 84.5024 98.197C84.5024 116.282 98.8019 130.899 116.454 130.899C98.8019 130.899 84.5024 145.566 84.5024 163.601Z"
          fill="#FFBC0D"
          stroke="black"
          strokeWidth="6.24"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5039_9533">
          <rect
            width="249.6"
            height="296.4"
            fill="white"
            transform="translate(31.2 15.6001)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AiIcon
